<template>
  <div class="c-monitor">
    <!-- filter -->
    <list-filter :operator-data="operatorData" :game-data="gameData" @on-change="filterData" />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <list-table
          :loading="loading"
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-detail="queryDetail"
          @on-retry="retryRule"
          @on-restart="restartPlan"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/shutdown_list_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, deepCopy } from '@/common/js/utils'
import { getShutdownList, retryShutdownPlanById, restartShutdownPlanById } from '@/api/manage.model'
import ListFilter from './components/list-filter'
import ListTable from './components/list-table.vue'
import { getSysMember, getCaoHuaGames } from '@/api/common.model'

export default {
  name: 'shutdownlist',
  mixins: [mixin],
  components: { ListFilter, ListTable },
  data() {
    return {
      tableHeight: 330,
      operatorData: [],
      gameData: []
    }
  },
  watch: {
    $route(to, from) {
      this.getData()
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getShutdownList(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    queryDetail(row) {
      const { id } = row
      this.$router.push({ name: 'shutdowndetail', query: { id } })
    },
    retryRule(params) {
      const { id } = params
      this.loading = true
      retryShutdownPlanById({ ruleId: id })
        .then((data) => {
          this.loading = false
          if (data) this.getData()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    restartPlan(params) {
      const { id } = params
      this.loading = true
      restartShutdownPlanById({ ruleId: id })
        .then((data) => {
          this.loading = false
          if (data) this.getData()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    preloadData() {
      Promise.all([getSysMember(), getCaoHuaGames()]).then((data) => {
        const [operatorData, gameData] = data
        if (isArray(operatorData)) this.operatorData = deepCopy(operatorData)
        if (isArray(gameData)) this.gameData = deepCopy(gameData)
      })
    },
    setLocalPage(size) {
      setLocal('SHUTDOWN_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('SHUTDOWN_PAGESIZE')) || 20
    this.tableCol = columns
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
